module.exports = __webpack_public_path__ + "static/MezzeBites_Illustration-a37f7cebd4d7e3ef5ff63a30fe237aca.png";